import { FileInfo } from "common/define";
import SystemConstant from "./SystemConstant";

export default class FileApi {
    static host = `${SystemConstant.protocol}://${SystemConstant.File.host}`;
    static getUrlStreamfile(file: FileInfo): string {
        return `${this.host}/${file.streamLocation.replace('./', '')}/${file.filename}`;
    }
}